<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">
                        피드 게시물 상세
                        <div class="clear"></div>
                    </div>
                    <feed-write-component :feedType="'detailFeed'" :feedKey="feedKey"></feed-write-component>
                    <div class="title pt30">
                        덧글 리스트
                        <div class="clear"></div>
                    </div>
                    <feed-comment-list-component :feedCommentType="'feedComment'" :defaultFilter="{'pa': feedKey}"></feed-comment-list-component>
                </div>
                <page-footer></page-footer>
            </div>
        </div>
    </div>
</template>

<script>
import FeedWriteComponent from "@/components/feed/FeedWriteComponent";
import FeedCommentListComponent from "@/components/feed/FeedCommentListComponent";

export default {
    name: 'FeedDetail',
    mixins: [],
    components: {FeedCommentListComponent,  FeedWriteComponent},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            feedKey: this.$route.params.wr_id,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
